import { FC, useMemo } from 'react';
import { SegmentSliderProps } from './types';
import ContentSliderSlide from './slide';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, tablet } from 'helpers/utils/screensizes';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import Typography from 'components/commercetools-ui/atoms/typography';
import Slider from 'components/commercetools-ui/atoms/slider';
import useWindowWidth from 'helpers/hooks/useBrowerWidth';
import Link from 'components/commercetools-ui/atoms/link';
const ContentSlider: FC<{ data?: any }> = ({ data }) => {
  const [isTabletSize] = useMediaQuery(tablet);
  const [isDesktopSize] = useMediaQuery(desktop);
  const { isTouchDevice } = useTouchDevice();
  const width = useWindowWidth();
  const slideWidth = useMemo(() => {
    if (isDesktopSize) return 496;
    else return isTabletSize ? 356 : 290;
  }, [isDesktopSize, isTabletSize]);
  const slidesElement = useMemo(
    () => data?.card_header_button_section?.map((slide: JSX.IntrinsicAttributes & SegmentSliderProps, index: string | number | null | undefined) =>
      <ContentSliderSlide key={index} {...slide} />),
    [data?.card_header_button_section],
  );
  
  return (
    <div
      className={`container-segment pb-48 pl-24 pt-48 md:px-28 lg:px-48 xl:px-60  xl:pb-40 xl:pt-60 2xl:pb-80 2xl:pl-61 2xl:pr-61 3xl:px-80 4xl:px-90`}
    >
      {data?.header?.section_title && (
        <Typography
          className="relative mb-36 text-32 font-medium leading-8 text-[#090909] md:mb-48 xl:text-32 xl:leading-[2.25rem] 2xl:text-48 2xl:leading-[3.25rem]"
          as="h3"
        >
          {data?.header?.section_title}
        </Typography>
      )}

      {width !== null && width >= 1120 ? (
        <>{getArrayGridComp(data)}</>
      ) : (
        <Slider
          dots={false}
          arrows={false}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          allowTouchMove={isTouchDevice}
          slideWidth={slideWidth}
          nextButtonStyles={{ transform: 'translateY(-150%)', right: '10px' }}
          prevButtonStyles={{ transform: 'translateY(-150%)', left: '10px' }}
          spaceBetween={16}
          slidesPerView={2.75}
        >
          {slidesElement}
        </Slider>
      )}
    </div>
  );
};

const IndividualCard = ({ image, card_title, ctas, styleProps, imageStyleProps, itemProps = {}, className }: any) => {
  const width = useWindowWidth();
  const commonColumnProps = { display: 'flex', flexDirection: 'column' };
 
  return (
    <Link style={{ ...commonColumnProps, ...styleProps }} className={`hover:bg-[#F3EDE9] cursor-pointer group ${className}`} link={ctas?.[0]?.button?.href||"#"}>
      <img src={image?.url} style={{ objectFit: 'cover', ...imageStyleProps }} />
      <div className={`lg:px-[12px] lg:pb-[0px]`}>
          <div className={`bg-[#F3EDE9] lg:bg-transparent`}>
          {card_title && (
            <Typography
                as="h4"
                className={`mt-10 pt-12 text-ellipsis flex flex-col text-16 font-medium leading-[20px] text-[#090909] md:text-16 lg:text-20 xl:text-18 2xl:text-22 ${width !== null && width < 375 ? 'min-h-[68px]' : ''}  ${width !== null && width < 570 ? 'min-h-[50px]' : ''} `}
              >
              {card_title}
            </Typography>
      )}
         {ctas && (
            <div className={`group-hover:translate-x-14`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="green">
                <path
                  d="M18 9L25 16M25 16L18 23M25 16L7 16"
                  stroke="#666666"
                  className=" group-hover:stroke-[#090909] block-md"
                  strokeWidth="2"
                  strokeLinecap="square"
                />
              </svg>
            </div>
          )}
        </div>
        </div>
    </Link>
    
  )
}

const getArrayGridComp = ({ card_header_button_section }: any) => {
  return (
    <div
      style={{ display: 'flex', width: '100%', gap: 50, alignItems: 'stretch' }}
      className={`${card_header_button_section?.[0].additional_css}`}
    >
      <IndividualCard
        {...card_header_button_section?.[0]}
        styleProps={{ flexBasis: '49%' }}
        imageStyleProps={{ width: '100%', height: '100%' }}
      />

      <div
        style={{
          flexBasis: '54%',
          display: 'grid',
          gap: 30,
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: '1fr 1fr',
        }}
        className={`${card_header_button_section?.[0].additional_css}`}
      >
        {card_header_button_section?.map((e: any, i: number) => {
          if (i === 0) return null;

          const isLastTwo = i >= card_header_button_section.length - 2;

          return (
            <IndividualCard
              {...e}
              key={i}
              styleProps={{ height: '100%' }}
              className={`${e.additional_css}`}
              imageStyleProps={{
                maxWidth: '100%',
                maxHeight: '100%',
                ...(isLastTwo ? { height: '78%' } : {}),
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ContentSlider;